import { render, staticRenderFns } from "./FormInputVisitsLimitOfMonth.vue?vue&type=template&id=c876eca2&scoped=true&lang=pug"
import script from "./FormInputVisitsLimitOfMonth.vue?vue&type=script&lang=ts"
export * from "./FormInputVisitsLimitOfMonth.vue?vue&type=script&lang=ts"
import style0 from "./FormInputVisitsLimitOfMonth.vue?vue&type=style&index=0&id=c876eca2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c876eca2",
  null
  
)

export default component.exports